export const SPLIT_NAMES = Object.freeze({
  ACCEPT_PAYMENTS_PAYMENT_EVENTS: 'commerce__accept_payments_payment_events',
  ACTIVE_EXPERIMENTS: 'active_experiments',
  ADS_DASHBOARD_RECENTLY_PURCHASED_CAROUSEL: 'ads_dashboard_recently_purchased_carousel',
  ADS_ENABLE_MOLOCO_AD_REPORTING: 'ads_pod_enable_moloco_ad_reporting',
  ADS_ENABLE_RECENTLY_PURCHASED_BRANDS_CAROUSEL: 'ads_enable_recently_purchased_brands_carousel',
  ADS_ENABLE_SHARE_MENU: 'ads_enable_share_menu',
  ADS_ENABLE_TOP_PURCHASED_PRODUCTS_CAROUSEL: 'ads_enable_top_purchased_products_carousel',
  ADS_ENABLE_VUEIFIED_SHARE_LEAFLINK: 'ads_enable_vueified_share_leaflink',
  ADS_IN_PLATFORM_PRODUCT_PROMOTION: 'ads_in_platform_product_promotion',
  ADS_PRODUCT_RECOMMENDATION: 'ads_product_recommendation',
  ADS_PRODUCT_SPOTLIGHT: 'ads_product_spotlight',
  ADS_SHOPPABLE_SKYSCRAPER: 'ads_shoppable_skyscraper',
  ADS_SPONSORSHIPS_IN_PRODUCT_SEARCH: 'ads_sponsorships_in_product_search',
  AUTO_AUTH: 'fire_pod__direct_pay_auto_authorization',
  AUTO_PAUSING_UPDATES: 'fire_pod__mp_auto_pausing_update',
  AUTO_PAUSING: 'fire_pod__mp_auto_pausing',
  AUTO_UPDATE_METRC_TEMPLATES: 'logistics_pod__enable_auto_update_of_metrc_templates',
  BANK_LINKING_MODAL: 'cop_pod__bank_linking',
  BIOTRACK_NY: 'traceability_pod__biotrack_new_york',
  BUYER_BIOTRACK_ONBOARDING: 'traceability__biotrack_buyer_onboarding',
  BUYER_DASHBOARD_OMS: 'psx_pod__buyer_dashboard',
  BUYER_METRC_ONBOARDING: 'ce_pod__buyer_metrc_onboarding',
  BUYER_SETTINGS_STORE_REQUESTS_VUE: 'buyer_settings_store_requests_vue',
  BUYER_SGO_REORDER: 'premium_retail__buyer_sgo_reorder',
  CAN_ACCESS_BUYER_REPORTS: 'retention_pod__buyer_reports',
  CAN_ACCESS_COMPANY_GROUP_FEATURES: 'can_access_company_group_features',
  CAN_ACCESS_LOGISTICS: 'enable_logistics_permission_to_all_users',
  CAN_SPLIT_ORDERS: 'ret_pod__split_orders',
  CAN_VIEW_BRAND_MENU_SOCIAL_LINKS: 'retention_pod__brand_menu_social_links',
  CART_PAYMENT_CTA: 'com_pod__cart_payment_cta',
  CART_PAYMENT_OPTION: 'com_pod__cart_payment_option',
  CART_REVERSE_FACTOR: 'com_pod__reverse_factor',
  CASHBACK_REWARDS: 'fire_pod__cashback_rewards',
  DASHBOARD_COLLAB_ORDERS: 'spliff_pod__collab_notification',
  DELINQUENT_LOCKDOWN: 'fire_pod__delinquent_lockdown',
  DELIVERED_STATUS: 'supply_chain_delivered_status',
  DIRECT_PAY_ENABLED_STATES: 'fire_pod__direct_pay_enabled_states',
  DIRECT_PAY_SELLER_FEE: 'fire_pod__direct_pay_seller_fee',
  ENABLE_CUSTOMERS_TO_SELECT_TRANSPORT: 'logistics_pod__enable_customers_to_select_transport_partner',
  ENROLLMENT_NUE_INTEGRATION: 'acct_man_pod__enrollment_nue_integration',
  FORCE_SEGMENT_REPORTING: 'force_segment_reporting',
  INBOUND_SHIPMENTS_CREATE: 'inbound_shipments_create',
  INTEGRATIONS_SELLER: 'npr_pod__integrations_seller',
  INTERNAL_APPROVALS: 'orders_internal_approvals',
  INTERNAL_PRODUCT_ID: 'saas_pod__internal_product_id',
  INVENTORY_BATCH: 'inventory_pod__inventory_batch_support',
  INVENTORY_FACILITY: 'inventory_pod__inventory_warehouse_support',
  KNOCK_NOTIFICATIONS_TOASTER: 'knock_notifications_toaster',
  KNOCK_NOTIFICATIONS: 'ogk_pod__knock_notifications',
  LEAFLINK_PLUS_ENROLLMENT_BILLING: 'llm_leaflink_plus_enrollment_billing',
  LISTINGS_ALLOCATIONS: 'inventory_pod__listings_allocations',
  LIVE_INVENTORY_INDICATOR: 'live_inventory_indicator',
  LLM_BUYERS_CLUB_ROLLOUT: 'llm_buyers_club_rollout',
  MANAGE_LICENSE__ADD_INTEGRATION__BUYER: 'manage_license__add_integration__buyer',
  MANAGE_LICENSE__NEW_METRC_FLOW: 'manage_licenses__new_metrc_flow',
  MANAGE_POST_SETTINGS: 'fire_pod__post_settings',
  MARKET_INSIGHTS_INFO_ALERT: 'cret_pod_marketscape_insights_historical_info_panel',
  MATCHING_MANIFESTS_TO_ORDERS: 'traceability_pod__matching_manifests_to_orders',
  MULTIPLE_PAYMENT_METHODS: 'enterprise_pod__mult_payment_methods',
  OMS_MP_TRACKING: 'oms_mp_tracking',
  ORDER_CREATE_V2: 'cret_pod__order_create',
  ORDER_SUMMARY_ANCILLARY_ENHANCEMENTS: 'order_summary_ancillary_enhancements',
  ORDER_SUMMARY_PAYMENTS_INVITE: 'gro_pod__order_summary_invitations',
  ORDER_SUMMARY_RECEIPT_LOG: 'order_summary_receipt_log',
  ORDERS_RECEIVED_DATAVIEW: 'orders_received_dataview',
  PAUSE_INACTIVE_LICENSE_COMPANIES: 'pause_inactive_license_companies',
  PAYMENT_ON_SELL_THROUGH_ALLOW_REMOVE_POST_FLAG: 'post_allow_remove_post_flag_from_order',
  PAYMENT_ON_SELL_THROUGH_ENROLLMENT: 'payment_on_sell_through__enrollment',
  PAYMENT_ON_SELL_THROUGH_PREAGREEMENT_SETTINGS: 'post_order_preagreement_settings',
  PAYMENT_ON_SELL_THROUGH_STS_UNIT_CONVERSION: 'post_sts_unit_conversion',
  PAYMENTS_EXPLORATION_WIDGET: 'cop_pod__payments_exploration_dashboard_widget',
  PAYMENTS_IN_CRM: 'collab_pod__payments_in_crm',
  PLAN_PRICE: 'acct_man_pod__plan_price',
  PLANS_AND_BILLING: 'acct_man_pod__plans_and_billing',
  PRINTED_MENU_QRCODE: 'gro_pod__printed_menu',
  PRODUCT_LIST_PAGE: 'inventory_pod__new_product_list_page',
  PROMO_CODE_DISPLAY: 'collab_pod__promo_code_display',
  REPLENISHMENT_CATALOG_PAGE: 'replenishment_catalog_page',
  RESTRICT_INVENTORY_INSIGHTS: 'llm_gate_inventory_insights_report',
  S2S_BULK_IMPORT_FROM_METRC: 'inte_pod__bulk_import_from_metrc',
  S2S_COA_DOWNLOAD: 'seed_to_sale_coa_download',
  S2S_LINK_RECONCILE_INVENTORY: 'traceability_pod__experiment__reconcile_inventory',
  S2S_TRANSFERS_BIOTRACK: 'traceability__biotrack_seller_transfers_page',
  S2S_TRANSFERS: 'trace_pod__s2s_transfers',
  SALES_REP_EMAIL_ACTIONS: 'collab_pod__sales_rep_email_actions',
  SEARCH_BY_ASSIGNED_PACKAGES: 'trace_pod__search_by_assigned_packages',
  SEED_TO_SALE__BUYER_MENU: 'seed_to_sale__buyer_nav',
  SELLER_BIOTRACK_ATTACH_MANIFEST: 'traceability__biotrack_seller_attach_manifest',
  SELLER_GLOBAL_POST_SETTINGS: 'fire_pod__seller_global_post_settings',
  SELLER_GPO_REPORT: 'llm_sigma_gpo_report',
  SELLER_ORDER_SUMMARY: 'acct_pod__seller_order_summary',
  SELLER_POST_SETTINGS: 'fire_pod__seller_post_settings',
  SELLER_RETENTION_CREATE_CUSTOM_MENU_REDESIGN: 'seller_retention_create_custom_menu_redesign',
  SELLER_RETENTION_CUSTOM_MENU_SHARING: 'seller_retention_custom_menu_sharing',
  SELLER_RETENTION_MULTI_STORE_ADD_LABEL: 'seller_retention_multi_store_add_label',
  SELLER_SETTINGS_VUE: 'seller_settings_vue',
  SETTINGS_BUYER_ACCOUNT_DETAILS: 'settings__buyer_account_details',
  SETTINGS_TAX_SCHEDULES: 'settings__tax_schedules',
  SHIPPING_REQUEST_DELIVERY_MODAL: 'shipping_request_delivery_modal',
  SHOW_SELL_THROUGH_FOR_NON_POST: 'show_sell_through_for_non_post',
  SSR_IFRAME: 'ssr_iframe',
  SUBMIT_ORDER_VIA_CSV_UPLOAD: 'logistics_pod__submit_order_via_csv_upload',
  SWITCH_CUSTOMER_FOR_CLONED_ORDERS: 'switch_customer_for_cloned_orders',
  TERMS_AND_CONDITIONS: 'cop_pod__terms_and_conditions',
  TRANSPORT_AUTO_POPULATE_PAYMENT: 'transport_pod__shipping_set_order_payments',
  TRANSPORT_MA_NEXT_DAY_DELIVERY: 'transport_pod__ma_next_day_delivery',
  VENDOR_MENU_UI: 'gro_pod__vendor_menu_ui_enhancement',
  VUE_BUYER_NOTIFICATION_SETTINGS: 'vue_buyer_notification_settings',
  VUE_INVENTORY_BULK_PRICE_UPDATE: 'vue_inventory_bulk_price_update',
  VUE_INVENTORY_PRODUCT_ADD_EDIT_PAGE: 'vue_inventory_product_add_edit_page',
  VUE_INVENTORY_PRODUCT_LINE_PAGE: 'vue_inventory_product_line_page',
  VUE_MESSAGES_PAGE: 'vue_messages_page',
  VUE_SELLER_REPORTS: 'llm_vue_seller_reports',
  VUE_SETTINGS_BRANDS_PAGE: 'vue_settings_brands_page',
} as const);

export const SPLIT_TREATMENTS = Object.freeze({
  CONTROL: 'control', // The default value if split.io is unavailable

  OFF: 'off',
  ON: 'on',

  // gro_pod__vendor_menu_ui_enhancement
  FULL: 'full',
  LIMITED: 'limited',

  // trace_pod__live_inventory_indicator
  BLUE_INDICATOR: 'blue-indicator',
  GREEN_INDICATOR: 'green-indicator',
  PACKAGES: 'packages',
  PRODUCTS: 'products',

  // products add/edit feature flag
  VUE_INVENTORY_PRODUCT_ADD_EDIT_PAGE_LEGACY: 'vue_inventory_product_add_edit_page_legacy',
  VUE_INVENTORY_PRODUCT_ADD_EDIT_PAGE_MVP: 'vue_inventory_product_add_edit_page_mvp',
} as const);
